var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlankNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2581 32.0625H7.125C6.81006 32.0625 6.50801 31.9374 6.28531 31.7147C6.06261 31.492 5.9375 31.1899 5.9375 30.875V7.125C5.9375 6.81006 6.06261 6.50801 6.28531 6.28531C6.50801 6.06261 6.81006 5.9375 7.125 5.9375H30.875C31.1899 5.9375 31.492 6.06261 31.7147 6.28531C31.9374 6.50801 32.0625 6.81006 32.0625 7.125V23.2581C32.0625 23.4141 32.0318 23.5685 31.9721 23.7126C31.9124 23.8566 31.825 23.9875 31.7147 24.0978L24.0978 31.7147C23.9875 31.825 23.8566 31.9124 23.7126 31.9721C23.5685 32.0318 23.4141 32.0625 23.2581 32.0625V32.0625Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9555 23.7488H23.75V31.9544",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankNote);
export default __webpack_public_path__ + "static/media/blank-note.0715fc33b7528b72a5a2f9a151c1fb6b.svg";
export { ForwardRef as ReactComponent };